import { ComponentPortal } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import domtoimage from 'dom-to-image-more';
import { ButtonThemeControl } from '../../../appbuilder/controls/button/button.theme.control';
import { CheckBoxThemeControl } from '../../../appbuilder/controls/checkbox/checkbox.control';
import { GenericMenuTab } from '../../../appbuilder/menutabs/generic/generic.menu.tab';
import { BasePanel } from '../../../appbuilder/panels/base.panel';
import { PropertyGroupDisplay } from '../../../models/enums/propertygroupdisplay.enum';
import { PROPERTIES, PROPERTYGROUPS } from '../../../services/dynamic.component.service';
import { LanguageService } from '../../../services/language.service';
import { LayoutService } from '../../../services/layout.service';
import { BaseDialog } from '../../dialogs/basedialog/base.dialog';
import { IBaseComponent } from '../base.component';
import { DocumentationDialog } from './documentation.dialog';
import { DocumentationEditDialog } from './documentation.edit.dialog';

@Component({
    selector: 'documentation-control',
    templateUrl: './documentation.control.html',
    styleUrls: ['./documentation.control.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentationControl extends IBaseComponent {
    static Type: any = 'documentation';
    static Default = {
        Type: 'documentation',
        Layout: {
            Editable: true
        }
    };
    static Meta = {
                Type: 'documentation',
                Properties: [
                ],
                Events: [
                ]
            };
    DoPrint = false;
    SelectedLanguage = -1;
    LanguageText;
    LanguageInnerHtml;

    constructor(private sanitizer: DomSanitizer, cdRef: ChangeDetectorRef, @Inject(LayoutService.CONTAINER_DATA) public data) {
        super(cdRef, data);
    }

    ControlInitialized() {
        if (!this.LayoutElementValue.DocumentationSettings) {
            this.LayoutElementValue.DocumentationSettings = {
                DefaultText: '',
                TranslatedTexts: []
            };
        }
        this.Subscriptions['LanguageChanged'] = LanguageService.SelectedLanguage.subscribe((x) => {
            if (x) {
                this.SelectedLanguage = x.LCID;
            } else {
                this.SelectedLanguage = -1;
            }
            this.checkText();
        });
    }

    onLayoutElementChanged() {
        this.checkText();
    }

    checkText() {
        let text = '';
        if (this.LayoutElementValue && this.LayoutElementValue.DocumentationSettings) {
            text = this.LayoutElementValue.DocumentationSettings.DefaultText;
            if (this.LayoutElementValue.DocumentationSettings.TranslatedTexts) {
                this.LayoutElementValue.DocumentationSettings.TranslatedTexts.some(y => {
                    if (y.LCID == this.SelectedLanguage) {
                        text = y.Text;
                        return true;
                    }
                    return false;
                });
            }
        }
        if (text) {
            this.LanguageInnerHtml = this.sanitizer.bypassSecurityTrustHtml(text);
        } else {
            this.LanguageInnerHtml = '';
        }
        this.LanguageText = text;
    }

    onClick() {
        DocumentationDialog.ShowDialog(this.LanguageText);
    }

    getScreenShot() {
        return new Promise<any>(resolve => {
            this.DoPrint = true;
            this.cdRef.detectChanges();
            let htmlElement = document.getElementById('LE_PRINT_' + this.LayoutElementValue.ID);
            if (htmlElement) {
                var that = this;
                domtoimage
                    .toPng(htmlElement)
                    .then(function (image) {
                        that.DoPrint = false;
                        that.cdRef.detectChanges();
                        resolve(image);
                    })
                    .catch(function (error) {
                        that.DoPrint = false;
                        that.cdRef.detectChanges();
                        resolve(null);
                    });
                return;
            }
        });
    }
}

export class DocumentationPanel extends BasePanel {
    static override SIDS = ['97ab4562-1def-4a49-8170-6336f4be3690'];
    static InitPanel() {
        PROPERTYGROUPS.push({
            SID: '97ab4562-1def-4a49-8170-6336f4be3690',
            ID: 'Documentation',
            Caption: '@@Documentation',
            Index: 100,
            Content: GenericMenuTab,
            Display: PropertyGroupDisplay.Grid,
            Columns: ['100%'],
            Rows: ['auto', 'auto', 'auto'],
            CheckVisibility: (item) => {
                return item.ElementType == 'documentation';
            }
        });

        PROPERTIES.push({
            ID: "DefineTexts",
            Parent: "Documentation",
            Content: new ComponentPortal(ButtonThemeControl),
            InitArgs: {
                Icon: 'edit',
                Action: (ev) => {
                    const selected = ev.SelectedItem;
                    if (selected) {
                        BaseDialog.ShowDialog({
                            ContentType: DocumentationEditDialog,
                            InitArgs: selected.DocumentationSettings,
                            Title: '@@Documentation',
                            Handler: (result) => {
                                if (result) {
                                    selected.DocumentationSettings.DefaultText = result.DefaultText;
                                    selected.DocumentationSettings.TranslatedTexts = result.TranslatedTexts;
                                    if (ev.Source && typeof ev.Source.onStyleChanged === 'function') {
                                        ev.Source.onStyleChanged();
                                    }
                                }
                                return true;
                            }
                        });
                    }
                }
            }
        });
        PROPERTIES.push({
            ID: "ShowAsMenu",
            Parent: "Documentation",
            Content: new ComponentPortal(CheckBoxThemeControl),
            InitArgs: {
                Caption: "@@ShowAsMenu"
            }
        });
    }
}
